export default __webpack_public_path__ + "static/media/wave3.431ad29b.svg";